"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'YsCheckboxGroup',
  props: {
    showCheckAll: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: Array
  },
  data() {
    return {
      checkAll: false,
      indeterminate: true,
      modelValue: this.value
    };
  },
  watch: {
    value: {
      handler(value) {
        this.modelValue = value;
      },
      deep: true
    },
    modelValue: {
      handler(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
      deep: true
    }
  },
  mounted() {
    this.indeterminate = !!this.modelValue?.length && this.modelValue?.length < this.options?.length;
    this.checkAll = this.modelValue?.length === this.options?.length;
  },
  methods: {
    handleCheckAllChange(e) {
      this.modelValue = e.target.checked ? this.options?.map(item => item.value) : [];
      this.indeterminate = false;
      this.checkAll = e.target.checked;
    },
    handleCheckChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.options?.length;
      this.checkAll = checkedList?.length === this.options?.length;
    }
  }
};